import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {amCharts_v4_date_line_template} from "./amCharts_v4_date_line_template";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { autoRefresh_template } from "./autoRefreshHidden_template";

declare var ko: any;

export class dashboard_template extends vnTemplate {

    protected shortTermReportTooltip: infoButton_template;
    protected shortTermReportTooltipContent;
    protected shortTermReportChart: amCharts_v4_date_line_template;
    protected autoRefresh: autoRefresh_template;
    protected trendPeriodToolTip: infoButton_template;
    protected lastWeekPeriodToolTip: infoButton_template;
    protected lastMonthPeriodToolTip: infoButton_template;

    protected prevTotalViews: any;
    protected prevAndroidPercent:any;
    protected prevAndroidPastPercent:any;
    protected prevMobilePercent:any;
    protected prevMobilePastPercent:any;
    protected prevUSAPercent:any;
    protected prevUSAPastPercent:any;
    protected prevPrimePercent:any;
    protected prevPrimePastPercent:any;
    protected prevTrend:any;
    protected prevPastWeek:any;
    protected prevPastMonth:any;
    protected prevVerifiedUsers:any;
    protected prevRegisteredUsers:any;
    protected prevActiveNewsletterSubscriptions:any;

    protected getTemplateHtml(): string{

        return `
        <div class="w-dashboard" data-bind="if: pageLoaded()">
            <div class="dashboard">
                <div class="w-card column-1 span-2 transparent-bg w-dashboard-header">
                    <div class="w-toggle">
                        <div class="latest-update">
                            <b> Last Updated: </b><span data-bind="text: latestUpdatedDate() == null ? 'Last Updated: N/A' : latestUpdatedDate()"></span>
                        </div>
                                            ` + this.autoRefresh.getHtmlBuild() + `
                    </div>
                    <div class="dashboard-header" data-bind="text: idBrand() ? 'Live Dashboard' : 'Network Live Dashboard'"></div>
                    <div class="sentinel">
                        <img src="/assets/images/sentinel.svg" alt="">
                    </div>
                </div>
            </div>
                <div id="dashboard" class="dashboard">
                    <div class="w-card transparent-bg top-section column-1 span-2">
                        <div class="w-card column-1 w-totals">
                            <div class="left-side">
                                <div class="card-header">
                                    <div class="dashboard-title">
                                        <div class="live-icon">
                                            <span class="live-text">Live</span>
                                        </div>
                                        Total Views
                                        <div class="w-tooltips-adv pos-bottom">
                                            ${this.lastWeekPeriodToolTip.getHtmlBuild()}
                                        </div>
                                    </div>
                                </div>
                                    <div class="w-total-page-views align-center">
                                    <div data-bind="visible: pageLoadingViews()" class="line total-views"></div>
                                    <div class="total-page-views" data-bind="text: totalPageViews_viewCount()"></div>
                                    <div class="w-total-delta align-center gap-5">
                                    <div data-bind="visible: pageLoadingTrends()" class="line trend"></div>
                                    <div data-bind="visible: pageLoadingTrends()" class="line trend2"></div>
                                        <div data-bind="visible: !pageLoadingTrends(), text: totalPageViews_trendPercentDifference() == null ? 'N/A' : totalPageViews_trendPercentDifference() > 0 ? '+' + totalPageViews_trendPercentDifference() + '%' : totalPageViews_trendPercentDifference() + '%',
                                            attr: {class: totalPageViews_trendPercentDifference() > 0 ? 'total-delta increase' : totalPageViews_trendPercentDifference() < 0 ? 'total-delta decrease' : 'total-delta neutral'}">
                                        </div>
                                        <div data-bind="visible: !pageLoadingTrends()" class="total-delta-label">Trend</div>
                                    </div>
                                </div>
                            </div>
                            <!--div class="w-total-delta-parent">
                                <div class="w-total-delta align-center gap-5">
                                    <div data-bind="visible: pageLoadingTrends()" class="line past-week"></div>
                                    <div data-bind="visible: pageLoadingTrends()" class="line past-week2"></div>
                                    <div data-bind="visible: !pageLoadingTrends(), text: totalPageViews_pastWeekPercentDifference() == null ? 'N/A' : totalPageViews_pastWeekPercentDifference() > 0 ? '+' + totalPageViews_pastWeekPercentDifference() + '%' : totalPageViews_pastWeekPercentDifference() + '%',
                                        attr: {class: totalPageViews_pastWeekPercentDifference() > 0 ? 'total-delta increase' : totalPageViews_pastWeekPercentDifference() < 0 ? 'total-delta decrease' : 'total-delta neutral'}">
                                    </div>
                                    <div data-bind="visible: !pageLoadingTrends()" class="total-delta-label">Last Week</div>
                                </div>
                                <div class="w-total-delta align-center gap-5">
                                    <div data-bind="visible: pageLoadingTrends()" class="line past-month"></div>
                                    <div data-bind="visible: pageLoadingTrends()" class="line past-month2"></div>

                                    <div data-bind="visible: !pageLoadingTrends(), text: totalPageViews_pastMonthPercentDifference() == null ? 'N/A' : totalPageViews_pastMonthPercentDifference() > 0 ? '+' + totalPageViews_pastMonthPercentDifference() + '%' : totalPageViews_pastMonthPercentDifference() + '%',
                                        attr: {class: totalPageViews_pastMonthPercentDifference() > 0 ? 'total-delta increase' : totalPageViews_pastMonthPercentDifference() < 0 ? 'total-delta decrease' : 'total-delta neutral'}">
                                    </div>
                                    <div data-bind="visible: !pageLoadingTrends()" class="total-delta-label">Last 4-Weeks</div>
                                </div>
                            </div-->
                        </div>

                        <div class="w-user-metrics w-card">
                        <div class="dashboard-title">
                            <span class="icon i i-newsletter">Total Subscriptions</span>
                        </div>
                        <div data-bind="visible: pageLoadingSubscriptions()" class="line subscriptions"></div>
                        <div class="total email" data-bind="text: totalActiveNewsletterSubscriptions()"></div>
                        </div>

                        <div class="w-user-metrics w-card">
                            <div class="dashboard-title">
                                <span class="icon i i-user">Total Accounts</span>
                            </div>
                            <div class="w-accounts">
                            <div data-bind="visible: pageLoadingAccounts()" class="line registered-users"></div>
                                <div class="total users" data-bind="text: totalRegisteredUsers()"></div>
                                <div class="w-verified-users">
                                    <div data-bind="visible: pageLoadingAccounts()" class="line verified-users"></div>
                                    <div class="verified-users" data-bind="text: totalVerifiedUsers()"></div>
                                    <div data-bind="visible: !pageLoadingAccounts()" class="verified-label">Verified</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-card column-1 span-2">
                        <div class="dashboard-title">
                            <span class="icon i i-hourfull">Rolling 24-Hours</span>
                            <div class="legend">
                                <span class="legend-current">Current</span>
                                <span class="legend-last-week">Last Week</span>
                        </div>
                        </div>
                        <svg class="spinner" data-bind="visible: pageLoadingViews()" viewBox="0 0 50 50">
                        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                        ${this.shortTermReportChart.getHtmlBuild()}
                    </div>
                    <div class="w-card transparent-bg column-1 span-2" style="display: flex;gap:10px;">
                        <div class="w-card w-key-segments-parent">
                            <div class="dashboard-title">
                                <div class="live-icon"><span class="live-text">Live</span></div>
                                <span>Key Segment Distribution</span>
                                <!--div class="legend"><span class="icon i i-4-week">Last 4-Weeks</span></div-->
                            </div>
                            <div class="w-key-segments">
                                <div class="w-gauge android">
                                    <div class="gauge-label">
                                        <div class="icon i i-android"></div>
                                        <span>Android</span>
                                    </div>
                                    <div data-bind="visible: pageLoadingSegments()" class="square circle"></div>
                                    <div class="pie" data-bind="visible: !pageLoadingSegments(), style: { '--p': keySegments_android_chart() }">
                                        <div class="gauge-current" data-bind="text: keySegments_android_currentPercent() + '%'"></div>
                                        <!--div class="gauge-4-week icon i i-4-week" data-bind="text: keySegments_android_pastPercent() + '%'"></div-->
                                    </div>
                                    <div class="image"></div>
                                </div>
                                <div class="w-gauge mobile">
                                    <div class="gauge-label">
                                        <div class="icon i i-mobile"></div>
                                        <span>Mobile</span>
                                    </div>
                                    <div data-bind="visible: pageLoadingSegments()" class="square circle"></div>
                                    <div class="pie" data-bind="visible: !pageLoadingSegments(), style: { '--p': keySegments_mobile_chart() }">
                                        <div class="gauge-current" data-bind="text: keySegments_mobile_currentPercent() + '%'"></div>
                                        <!--div class="gauge-4-week icon i i-4-week" data-bind="text: keySegments_mobile_pastPercent() + '%'"></div-->
                                    </div>
                                    <div class="image"></div>

                                </div>
                                <div class="w-gauge usa">
                                    <div class="gauge-label">
                                        <div class="icon i i-usa"></div>
                                        <span>USA</span>
                                    </div>
                                    <div data-bind="visible: pageLoadingSegments()" class="square circle"></div>
                                    <div class="pie" data-bind="visible: !pageLoadingSegments(), style: { '--p': keySegments_us_chart() }">
                                        <div class="gauge-current" data-bind="text: keySegments_us_currentPercent() + '%'"></div>
                                        <!--div class="gauge-4-week icon i i-4-week" data-bind="text: keySegments_us_pastPercent() + '%'"></div-->
                                    </div>
                                    <div class="image"></div>

                                </div>
                                <div class="w-gauge prime">
                                <div class="gauge-label">
                                    <div class="icon i i-prime"></div>
                                    <span>Prime Geos</span>
                                </div>

                                <div data-bind="visible: pageLoadingSegments()" class="square circle"></div>
                                <div class="pie" data-bind="visible: !pageLoadingSegments(), style: { '--p': keySegments_primeGeo_chart() }">
                                    <div class="gauge-current" data-bind="text: keySegments_primeGeo_currentPercent() + '%'"></div>
                                    <!--div class="gauge-4-week icon i i-4-week" data-bind="text: keySegments_primeGeo_pastPercent() + '%'"></div-->
                                </div>
                                <div class="image"></div>

                            </div>
                            </div>
                            </div>


                        <div class="w-card w-table">
                            <div class="dashboard-title">
                                <div class="live-icon">
                                    <span class="live-text">Live</span>
                                </div>
                                Top Articles
                            </div>
                            <table>
                                <thead class="table-header">
                                    <tr>
                                        <th>Rank</th>
                                        <th>Article</th>
                                        <th>Views</th>
                                        <th>Engagement%</th>
                                    </tr>
                                </thead>
                                <tbody class="table-body" data-bind="foreach: topArticles, style: { opacity: topArticlesOpacity() }">
                                    <tr data-bind="event: { click: $parent.onClickViewArticle }">
                                        <td data-bind="text: $data.newPosition"></td>
                                        <!--td>
                                            <div data-bind="text: Number.isNaN(Math.abs($data.positionDifference)) ? '+' : Math.abs($data.positionDifference) == 0 ? '' : Math.abs($data.positionDifference),
                                                attr: {class: Number.isNaN(Math.abs($data.positionDifference)) ? 'rank null' : $data.positionDifference > 0 ? 'rank increase' : $data.positionDifference < 0 ? 'rank decrease' : 'rank neutral'}">
                                            </div>
                                        </td-->
                                        <td class="w-table-article">
                                            <span class="brand-item dark" data-bind="css: $data.brandIconImage"></span>
                                            <div class="article" data-bind="text: $data.articleTitle"></div>
                                        </td>
                                        <td>
                                            <div data-bind="text: $data.totalViews"></div>
                                        </td>
                                        <!--td>
                                            <div data-bind="text: $data.viewDifference == null ? '' : $data.viewDifference + '%',
                                                attr: {class: $data.viewDifference > 0 ? 'increase' : $data.viewDifference < 0 ? 'decrease' : 'neutral'}">
                                            </div>
                                        </td-->
                                        <td data-bind="text: $data.engagementRate"></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div data-bind="visible: pageLoadingSegments()" class="row">
                            <div data-bind="visible: pageLoadingSegments()" class="line article"></div>
                            <div data-bind="visible: pageLoadingSegments()" class="line article2"></div>
                            <div data-bind="visible: pageLoadingSegments()" class="line article3"></div>
                            <div data-bind="visible: pageLoadingSegments()" class="line article4"></div>
                            </div>

                            <div data-bind="visible: pageLoadingSegments()" class="row">
                            <div data-bind="visible: pageLoadingSegments()" class="line article5"></div>
                            <div data-bind="visible: pageLoadingSegments()" class="line article6"></div>
                            <div data-bind="visible: pageLoadingSegments()" class="line article7"></div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        `;
    }

    protected initPartial():void{


        this.shortTermReportChart = new amCharts_v4_date_line_template("amCharts_v4_date_dashboard_line_template", this.getTemplateViewModel(), this.caller);
        this.shortTermReportChart.setXAxisRotation(0);
        this.shortTermReportChart.setXAxisFontSize(10);
        this.shortTermReportChart.getTemplateViewModel().cssHeight("130px");
        this.shortTermReportChart.getTemplateViewModel().cssWidth("100%");

        this.autoRefresh = new autoRefresh_template('autoRefresh_dashboard', this.getTemplateViewModel(), this.caller);
        this.autoRefresh.setRefreshFrequency(300000);


        let lastWeekPeriodToolTipContent = `
        <p><b>Trend:</b><br>Moving average that compares the most recent 6 periods (30 minutes) with the most recent 24 periods (2 hours).</p>
        <p><b>Last Week:</b><br>Compares the current period to the average of the hour preceding the same period last week (same period last week is included).</p>
        <p><b>Last 4 Weeks:</b><br>Compares the current period to the average of the hour preceding the same period in the last 4 weeks (same period in the last 4 weeks is included).</p>
        `;

        this.lastWeekPeriodToolTip = new infoButton_template('lastWeekPeriodToolTip', this.getTemplateViewModel(), this.caller)
        this.lastWeekPeriodToolTip.setTitle('');
        this.lastWeekPeriodToolTip.setContent(lastWeekPeriodToolTipContent);
    }

    protected getTemplateName(): string{

        return "dashboard_template";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{
            pageLoaded: ko.observable(false),
            pageLoadingViews: ko.observable(true),
            pageLoadingSegments: ko.observable(true),
            pageLoadingAccounts: ko.observable(true),
            pageLoadingTrends: ko.observable(true),
            pageLoadingSubscriptions: ko.observable(true),
            totalPageViews_viewCount: ko.observable(null),
            totalPageViews_trendPercentDifference: ko.observable(null),
            totalPageViews_pastWeekPercentDifference: ko.observable(null),
            totalPageViews_pastMonthPercentDifference: ko.observable(null),
            performance24hr: ko.observable(),
            keySegments_android_other: ko.observable(),
            keySegments_mobile_other: ko.observable(),
            keySegments_us_other: ko.observable(),
            keySegments_primeGeo_other: ko.observable(),
            keySegments_android_currentPercent: ko.observable(0),
            keySegments_mobile_currentPercent: ko.observable(0),
            keySegments_us_currentPercent: ko.observable(0),
            keySegments_primeGeo_currentPercent: ko.observable(0),
            keySegments_android_pastPercent: ko.observable(0),
            keySegments_mobile_pastPercent: ko.observable(0),
            keySegments_us_pastPercent: ko.observable(0),
            keySegments_primeGeo_pastPercent: ko.observable(0),
            keySegments_android_chart: ko.observable(),
            keySegments_mobile_chart: ko.observable(),
            keySegments_us_chart: ko.observable(),
            keySegments_primeGeo_chart: ko.observable(),
            topArticles: ko.observableArray([]),
            topArticlesOpacity: ko.observableArray([]),
            totalRegisteredUsers: ko.observable(null),
            totalVerifiedUsers: ko.observable(null),
            totalActiveNewsletterSubscriptions: ko.observable(null),
            idBrand: ko.observable(this.caller.getVnAppZone().app.params.idBrand),
            latestUpdatedDate: ko.observable(null),
            onClickViewArticle: function (data, event){
                huit_neuf_this.onClickViewArticle(data, event);
            },
            animateValue: function(obj,start,end,duration){
                huit_neuf_this.animateValue(obj,start,end,duration)
            },
            animatePieChart: function(element,startPercent,endPercent,duration){
                huit_neuf_this.animateValue(element,startPercent,endPercent,duration)
            },
            animatePercentage: function(element,startPercent,endPercent,duration){
                huit_neuf_this.animateValue(element,startPercent,endPercent,duration)
            }
        }
    }

    public animatePieChart(element, startPercent, endPercent, duration) {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) {
                startTimestamp = timestamp;
            }
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            const currentPercent = Math.floor(progress * (endPercent - startPercent) + startPercent);
            element(currentPercent)
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }

    public loadPage(){
        this.getTemplateViewModel().pageLoaded(true);
    }


    public animatePercentage(element, startPercent, endPercent, duration) {

        let startTimestamp = null;

        function customEase(t) {
            return 1 - Math.pow(1 - t, 6); // Cubic easing
        }

        const step = (timestamp) => {
            if (!startTimestamp) {
                startTimestamp = timestamp;
            }

            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            const easedProgress = customEase(progress);
            const currentPercent = (startPercent + (endPercent - startPercent) * easedProgress).toFixed(1);

            // Set the new content current percentage
            element(currentPercent);

            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }




    public animateValue(obj, start, end, duration) {
        let currentCount = start;
        let startTime = null; // Initialize startTime outside the updateCount function

        function customEase(t) {
            return 1 - Math.pow(1 - t, 6); // Cubic easing
        }

        function updateCount(timestamp) {
            if (!startTime) {
                startTime = timestamp; // Initialize startTime only once
            }

            const elapsedTime = timestamp - startTime;
            const progress = Math.min(elapsedTime / duration, 1); // Ensure progress doesn't exceed 1
            // Apply custom easing function to slow down significantly near the end
            const easedProgress = customEase(progress);
            // Calculate current count based on targetCount and progress
            currentCount = Math.floor(start + (end - start) * easedProgress); // Calculate current count based on start and end values
            obj(currentCount.toLocaleString());

            if (progress < 1) {
                requestAnimationFrame(updateCount);
            }
        }
        requestAnimationFrame(updateCount);
    }


    public getViewModelForRequest(){

        return{
            autoRefreshEnabled: this.autoRefresh.getTemplateViewModel().toggleAutoRefresh(),
            autoRefresh: this.autoRefresh.getTemplateViewModel().callRefresh(),
        }
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){
            this.autoRefresh.setToggleAutoRefresh(urlParams.autoRefreshEnabled);
        }
    }

    public setResults(results) {

        if (results) {

            const duration = 1500;
            const shorterDuration = 1000;
            const longerDuration = 2000;

            if (results.holdingBack) {
                console.log("Result Date:" + results.holdingBack.date + " Brand:" + results.holdingBack.brand);
            }

            if (results.realTimeTicker && results.realTimeTicker.latest) {
                if (results.realTimeTicker.latest) {


                    const totalViews = typeof results.realTimeTicker.latest.viewCount === 'string' ? parseInt(results.realTimeTicker.latest.viewCount.replace(/,/g, '')) : results.realTimeTicker.latest.viewCount;

                    this.prevTotalViews ? this.animateValue(this.getTemplateViewModel().totalPageViews_viewCount, this.prevTotalViews, totalViews, longerDuration)
                        : this.animateValue(this.getTemplateViewModel().totalPageViews_viewCount, 0, totalViews, duration);

                    this.prevTotalViews = totalViews;
                }
            }

            if (results.realTimeTicker) {
                if (results.realTimeTicker.trendPercentDifference) {

                    const pastTrendPercent = parseFloat(results.realTimeTicker.trendPercentDifference);

                    this.prevTrend ? this.animatePercentage(this.getTemplateViewModel().totalPageViews_trendPercentDifference, this.prevTrend, pastTrendPercent, longerDuration)
                        : this.animatePercentage(this.getTemplateViewModel().totalPageViews_trendPercentDifference, 0, pastTrendPercent, duration);


                    this.prevTrend = pastTrendPercent;
                }
                if (results.realTimeTicker.pastWeekPercentDifference) {

                    const pastWeekPercent = parseFloat(results.realTimeTicker.pastWeekPercentDifference);

                    this.prevPastWeek ? this.animatePercentage(this.getTemplateViewModel().totalPageViews_pastWeekPercentDifference, this.prevPastWeek, pastWeekPercent, longerDuration)
                        : this.animatePercentage(this.getTemplateViewModel().totalPageViews_pastWeekPercentDifference, 0, pastWeekPercent, duration);

                    this.prevPastWeek = pastWeekPercent;

                }
                if (results.realTimeTicker.pastMonthPercentDifference) {

                    const pastMonthPercent = parseFloat(results.realTimeTicker.pastMonthPercentDifference);

                    this.prevPastMonth ? this.animatePercentage(this.getTemplateViewModel().totalPageViews_pastMonthPercentDifference, this.prevPastMonth, pastMonthPercent, longerDuration)
                        : this.animatePercentage(this.getTemplateViewModel().totalPageViews_pastMonthPercentDifference, 0, pastMonthPercent, duration);

                    this.prevPastMonth = pastMonthPercent;
                }
            }

            if (results.keySegments) {

                //const currentAndroidPercent = parseFloat(results.keySegments.androidVnon.currentPercent);
                //const pastAndroidPiePercent = parseFloat(results.keySegments.androidVnon.pastPercent);
                const currentAndroidPercent = parseFloat( results.keySegments.os.Android ? results.keySegments.os.Android.percentage : 0);

                //const currentMobilePercent = parseFloat(results.keySegments.mobileVnon.currentPercent);
                //const pastMobilePiePercent = parseFloat(results.keySegments.mobileVnon.pastPercent);
                const currentMobilePercent = parseFloat( results.keySegments.device.Mobile ? results.keySegments.device.Mobile.percentage : 0);

                //const currentUSAPercent = parseFloat(results.keySegments.usVnon.currentPercent);
                //const pastUSAPiePercent = parseFloat(results.keySegments.usVnon.pastPercent);
                const currentUSAPercent = parseFloat( results.keySegments.geo['United States'] ? results.keySegments.geo['United States'].percentage : 0);

                //const currentPrimePercent = parseFloat(results.keySegments.primeVnon.currentPercent);
                //const pastPrimePiePercent = parseFloat(results.keySegments.primeVnon.pastPercent);
                const currentPrimePercent = parseFloat( results.keySegments.geo.Prime ? results.keySegments.geo.Prime.percentage : 0);


                if (this.prevAndroidPastPercent) {

                    // Animate from previous to current percentage
                    this.animatePieChart(this.getTemplateViewModel().keySegments_android_chart, this.prevAndroidPercent, currentAndroidPercent, duration);
                    this.animatePercentage(this.getTemplateViewModel().keySegments_android_currentPercent, this.prevAndroidPercent, currentAndroidPercent, duration);
                    //this.animatePercentage(this.getTemplateViewModel().keySegments_android_pastPercent, this.prevAndroidPastPercent, pastAndroidPiePercent, duration);

                    this.animatePieChart(this.getTemplateViewModel().keySegments_mobile_chart, this.prevMobilePercent, currentMobilePercent, duration);
                    this.animatePercentage(this.getTemplateViewModel().keySegments_mobile_currentPercent, this.prevMobilePercent, currentMobilePercent, duration);
                    //this.animatePercentage(this.getTemplateViewModel().keySegments_mobile_pastPercent, this.prevMobilePastPercent, pastMobilePiePercent, duration);

                    this.animatePieChart(this.getTemplateViewModel().keySegments_us_chart, this.prevUSAPercent, currentUSAPercent, duration);
                    this.animatePercentage(this.getTemplateViewModel().keySegments_us_currentPercent, this.prevUSAPercent, currentUSAPercent, duration);
                    //this.animatePercentage(this.getTemplateViewModel().keySegments_us_pastPercent, this.prevUSAPastPercent, pastUSAPiePercent, duration);

                    this.animatePieChart(this.getTemplateViewModel().keySegments_primeGeo_chart, this.prevPrimePercent, currentPrimePercent, duration);
                    this.animatePercentage(this.getTemplateViewModel().keySegments_primeGeo_currentPercent, this.prevPrimePercent, currentPrimePercent, duration);
                    //this.animatePercentage(this.getTemplateViewModel().keySegments_primeGeo_pastPercent, this.prevPrimePastPercent, pastPrimePiePercent, duration);

                }
                else {

                    // Animate from previous to current percentage
                    this.animatePieChart(this.getTemplateViewModel().keySegments_android_chart, 0, currentAndroidPercent, duration);
                    this.animatePercentage(this.getTemplateViewModel().keySegments_android_currentPercent, 0, currentAndroidPercent, longerDuration);
                    //this.animatePercentage(this.getTemplateViewModel().keySegments_android_pastPercent, 0, pastAndroidPiePercent, longerDuration);

                    this.animatePieChart(this.getTemplateViewModel().keySegments_mobile_chart, 0, currentMobilePercent, duration);
                    this.animatePercentage(this.getTemplateViewModel().keySegments_mobile_currentPercent, 0, currentMobilePercent, longerDuration);
                    //this.animatePercentage(this.getTemplateViewModel().keySegments_mobile_pastPercent, 0, pastMobilePiePercent, longerDuration);

                    this.animatePieChart(this.getTemplateViewModel().keySegments_us_chart, 0, currentUSAPercent, duration);
                    this.animatePercentage(this.getTemplateViewModel().keySegments_us_currentPercent, 0, currentUSAPercent, longerDuration);
                    //this.animatePercentage(this.getTemplateViewModel().keySegments_us_pastPercent, 0, pastUSAPiePercent, longerDuration);

                    this.animatePieChart(this.getTemplateViewModel().keySegments_primeGeo_chart, 0, currentPrimePercent, duration);
                    this.animatePercentage(this.getTemplateViewModel().keySegments_primeGeo_currentPercent, 0, currentPrimePercent, longerDuration);
                    //this.animatePercentage(this.getTemplateViewModel().keySegments_primeGeo_pastPercent, 0, pastPrimePiePercent, longerDuration);
                }

                //this.prevAndroidPastPercent = pastAndroidPiePercent
                this.prevAndroidPercent = currentAndroidPercent;

                //this.prevMobilePastPercent = pastMobilePiePercent
                this.prevMobilePercent = currentMobilePercent;

                //this.prevUSAPastPercent = pastUSAPiePercent
                this.prevUSAPercent = currentUSAPercent;

                //this.prevPrimePastPercent = pastPrimePiePercent
                this.prevPrimePercent = currentPrimePercent;

            }

            if (results.userStats) {

                if (results.userStats.verifiedUsers) {
                    const totalVerifiedUsers = parseInt(results.userStats.verifiedUsers);

                    this.prevVerifiedUsers ? this.animateValue(this.getTemplateViewModel().totalVerifiedUsers, this.prevVerifiedUsers, totalVerifiedUsers, longerDuration)
                        : this.animateValue(this.getTemplateViewModel().totalVerifiedUsers, 0, totalVerifiedUsers, duration);

                    this.prevVerifiedUsers = totalVerifiedUsers;
                }

                if (results.userStats.registeredUsers) {
                    const totalRegisteredUsers = parseInt(results.userStats.registeredUsers);

                    this.prevRegisteredUsers ? this.animateValue(this.getTemplateViewModel().totalRegisteredUsers, this.prevRegisteredUsers, totalRegisteredUsers, longerDuration)
                        : this.animateValue(this.getTemplateViewModel().totalRegisteredUsers, 0, totalRegisteredUsers, duration);

                    this.prevRegisteredUsers = totalRegisteredUsers;
                }
            }

            if(results.newsletterSubscriptions && results.newsletterSubscriptions.activeSubscriptions){
                const totalActiveNewsletterSubscriptions = parseInt(results.newsletterSubscriptions.activeSubscriptions);

                this.prevActiveNewsletterSubscriptions ? this.animateValue(this.getTemplateViewModel().totalActiveNewsletterSubscriptions, this.prevActiveNewsletterSubscriptions, totalActiveNewsletterSubscriptions, longerDuration)
                    : this.animateValue(this.getTemplateViewModel().totalActiveNewsletterSubscriptions, 0, totalActiveNewsletterSubscriptions, duration);
                this.prevActiveNewsletterSubscriptions = totalActiveNewsletterSubscriptions;
            }

            if (results.topArticles) {
                this.getTemplateViewModel().topArticles(results.topArticles);
            }


            if (results.type == "views") {
                this.getTemplateViewModel().pageLoadingViews(false);
            }

            if (results.type == "trends") {
                this.getTemplateViewModel().pageLoadingTrends(false);
            }

            if (results.type == "accounts") {
                this.getTemplateViewModel().pageLoadingAccounts(false);
            }

            if (results.type == "subscriptions") {
                this.getTemplateViewModel().pageLoadingSubscriptions(false);
            }

            if (results.type == "segments") {
                this.getTemplateViewModel().pageLoadingSegments(false);

                this.getTemplateViewModel().topArticlesOpacity(0)

                setTimeout(() => {
                    this.getTemplateViewModel().topArticlesOpacity(1)
                }, 500);
            }

            if (!results.type) {
                this.getTemplateViewModel().pageLoadingViews(false);
                this.getTemplateViewModel().pageLoadingTrends(false);
                this.getTemplateViewModel().pageLoadingAccounts(false);
                this.getTemplateViewModel().pageLoadingSegments(false);
                this.getTemplateViewModel().pageLoadingSubscriptions(false);
            }

            this.getTemplateViewModel().pageLoaded(true);


            if (results.latestUpdate) {
                const date = new Date(results.latestUpdate.date);
                const dateFormat = date.toLocaleDateString() + ' - ' + date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
                this.getTemplateViewModel().latestUpdatedDate(dateFormat);
            }

            if (results.dayPerformance) {
                this.getTemplateViewModel().performance24hr(results.dayPerformance);
                this.setShortTermReport(results.dayPerformance);
            }
        }
    }

    public onClickRefresh(){

        this.caller.getDataSubscriptions();
        this.caller.getDataAccounts();
        this.caller.getDataSegments();
        this.caller.getDataTrends();
        this.caller.getDataViews();
    }

    public onClickViewArticle(data, event){
        if(event.target.id.indexOf("site-view") == -1){
            this.caller.viewArticle(data.articleId, data.idBrand);
        }
    }

    public setShortTermReport(shortTermReport): void {

        this.shortTermReportChart.setDate('date');
        this.shortTermReportChart.setMinGridDistance(20);
        this.shortTermReportChart.setShow6HrsInterval(true);

        this.shortTermReportChart.setInterval([
            {timeUnit: "minute", count: 5}
        ]);

        // set y axis
        let yaxis = [];

        yaxis.push({
            field: "recentViewCount",
            name:  'Current Period',
            axis: "main",
            color: "#6891DC",
            opposite: false,
            bullet: "none",
            tooltipText: "{name}: [bold]{valueY}{percentDifferenceText}[/]"
        });
        yaxis.push({
            field: "pastViewCount",
            name:  'Same Period Last Week',
            axis: "main",
            color: "#E69E78",
            opposite: false,
            bullet: "none"
        });

        this.shortTermReportChart.setYaxis(yaxis);

        let ranges = [];

        this.shortTermReportChart.setRanges(ranges);

        this.shortTermReportChart.drawChart(shortTermReport);

        this.shortTermReportChart.show();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/dashboard_template.ts